import { useMemo } from 'react';

export default function useDetailedStats(userProgress) {
  const statsData = useMemo(() => {
    // 1. Verificación de seguridad
    if (!userProgress) {
      return {
        accuracy: '0%',
        completedLessons: 0,
        studyTimeFormatted: '0m',
        studyTimeFullText: '0 minutos'
      };
    }

    // --- CÁLCULO DE LECCIONES ---
    const completedLessons = userProgress.completedSets?.length || 0;

    // --- CÁLCULO DE TIEMPO (De minutos a formato h/m) ---
    const totalMinutes = userProgress.studyMinutes || 0;
    const hours = Math.floor(totalMinutes / 60);
    const minutesLeft = totalMinutes % 60;

    let studyTimeFormatted = '0m';
    if (hours > 0) {
      studyTimeFormatted = `${hours}h`; // Ejemplo: 18h
    } else {
      studyTimeFormatted = `${totalMinutes}m`; // Ejemplo: 45m
    }

    // --- CÁLCULO DE PRECISIÓN (ACCURACY) ---
    // Usamos los nuevos datos que agregamos a saveToLocal
    const correct = userProgress.totalCorrectAnswers || 0;
    const total = userProgress.totalAnswers || 0;
    
    let accuracyValue = 0;
    if (total > 0) {
      accuracyValue = Math.round((correct / total) * 100);
    } else if (completedLessons > 0) {
      // Fallback por si hay lecciones pero no se guardó el histórico aún
      accuracyValue = 85; 
    }

    return {
      accuracy: `${accuracyValue}%`,
      completedLessons,
      studyTimeFormatted,
      // Texto largo por si quieres usarlo en un tooltip o detalle
      studyTimeFullText: hours > 0 
        ? `${hours} horas ${minutesLeft} min` 
        : `${totalMinutes} minutos`
    };

  }, [userProgress]);

  return statsData;
}